module.exports = __webpack_public_path__ + "media/images/products/icook-desktop-34b595c9b4b77f9cbda90aafa7ee875a.png";